import API from "..";
import { errorStatusHandle } from "../../utils/error-utils";

const getAppSettings = async () => {
  try {
    const response = await API.get("settings");
    return response.data.data;
  } catch (e) {
    errorStatusHandle(e)
    throw e.response;
  }
};

export { getAppSettings };
